import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import HowToContents from './HowToContents';

function HowToGuide() {
  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        {/* Start flex container */}
          <div className='m-0 p-0 is-flex is-flex-direction-column is-justify-content-start'>

            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='p-0 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-8-fullhd is-8-widescreen is-10-desktop is-10-tablet is-10-mobile">
                <h1 className='pt-4 m-0'>How to guide</h1>
              </div>
            </div>

            {/* How to guide */}
            <HowToContents />
            
            {/* Footer */}
            <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
              <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
            </div>

          </div> 
          {/* End flex container */}
      </section>
    </>
  );
}

export default HowToGuide;